import { isValidIpAddress } from "./is-valid-ip-address";

const isValidHostname = (hostname: string): boolean => {
  if (!hostname || hostname.length > 253) {
    return false;
  }

  const labels = hostname.split(".");

  return labels.every((label) => {
    if (!label || label.length > 63) {
      return false;
    }

    if (!/^[a-zA-Z0-9-]+$/.test(label)) {
      return false;
    }

    return !label.startsWith("-") && !label.endsWith("-");
  });
};

export const isValidHostnameOrIpAddress = (value: string): boolean => {
  const normalizedValue = value.trim();

  if (!normalizedValue) {
    return false;
  }

  return isValidIpAddress(normalizedValue) || isValidHostname(normalizedValue);
};
